package ai.jessie.shared.members

import kotlinx.serialization.Serializable

// UC-005. UUIDs and instants are JSON strings; role, status and outcome names are uppercase.
// `version` and `expiresAt` are opaque stale-change tokens: return them unchanged.
@Serializable
data class MemberResponse(
    val memberId: String,
    val role: String,
    val status: String,
    val version: String,
    val self: Boolean,
    val displayName: String? = null,
    val email: String? = null,
)

// The separate UC-031 email outcome (BR-026). It never means the invitation was read.
@Serializable
data class InvitationEmailResponse(
    val messageId: String,
    val outcome: String,
    val outcomeAt: String? = null,
)

@Serializable
data class InvitationResponse(
    val invitationId: String,
    val email: String,
    val role: String,
    val status: String,
    val expiresAt: String,
    val expired: Boolean,
    val emailOutcome: InvitationEmailResponse? = null,
)

@Serializable
data class MemberManagementResponse(
    val members: List<MemberResponse>,
    val invitations: List<InvitationResponse>,
)

// `management` is absent when the change ended the actor's own owner authority.
@Serializable data class MemberChangeResponse(val management: MemberManagementResponse? = null)

@Serializable data class IssueInvitationRequest(val email: String, val role: String)

// Resend and revoke: status and expiry copied from the listed invitation.
@Serializable
data class InvitationChangeRequest(val expectedStatus: String, val expectedExpiresAt: String)

@Serializable
data class ChangeMemberRoleRequest(
    val role: String,
    val expectedRole: String,
    val expectedVersion: String,
)

@Serializable data class RemoveMemberRequest(val expectedRole: String, val expectedVersion: String)
